var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditMaskIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1953_2153",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1953_2153)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70774 18.8981L6.24172 19H6.20774C5.88492 19 5.57909 18.8641 5.35822 18.6432C5.12036 18.4223 4.98443 18.0995 5.00142 17.7597L5.10337 14.2937C5.12036 13.9879 5.23929 13.699 5.46016 13.4782L13.5645 5.3568C14.0233 4.88107 14.7878 4.88107 15.2636 5.3568L18.6276 8.73786C18.8655 8.95874 18.9844 9.26456 18.9844 9.58738C18.9844 9.91019 18.8485 10.216 18.6276 10.4369L10.5233 18.5413C10.3024 18.7621 10.0136 18.8811 9.70774 18.8981ZM17.5574 9.57053L14.4142 6.42733L6.46273 14.3958L6.41176 15.9759L8.02584 17.59L9.60594 17.539L17.5574 9.57053Z",
    fill: "#1EC252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89334 16.4515C9.02926 16.5874 9.19916 16.6553 9.36906 16.6553C9.53897 16.6553 9.70887 16.5874 9.84479 16.4515L16.0293 10.267C16.3011 9.99515 16.3011 9.57039 16.0293 9.29855C15.7574 9.0267 15.3327 9.0267 15.0608 9.29855L8.89334 15.5C8.62149 15.7549 8.62149 16.1966 8.89334 16.4515Z",
    fill: "#1EC252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02629 15.3131C8.19619 15.3131 8.3661 15.2452 8.50202 15.1092L14.6865 8.92477C14.9583 8.65293 14.9583 8.22817 14.6865 7.95632C14.4146 7.68448 13.9899 7.68448 13.718 7.95632L7.55056 14.1578C7.27872 14.4296 7.27872 14.8544 7.55056 15.1262C7.68649 15.2452 7.85639 15.3131 8.02629 15.3131Z",
    fill: "#1EC252"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditMaskIcon);
export default __webpack_public_path__ + "static/media/EditMaskIcon.a13cb226.svg";
export { ForwardRef as ReactComponent };